import { gql } from '@apollo/client';

export default gql`
  query Query($lineId: String!) {
    vacationTypes(lineId: $lineId)
  }
`;
